module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

const item = element.data;
const addLinkClass = '#popup_article' === target ? 'en_js_open_popup acl_js_load_popup' : '';
const addLinkAttributes = '#popup_article' === target ? 'data-en-popup-target="' + target + '"' : ''
const isChanel = [ 'CHANEL' ].includes( item.brand.toUpperCase() );

const productUrl = item.url.split( '/' );
const detailPageUrl = '/' + productUrl[ productUrl.length - 1 ];

const addClass = [].concat( element.addClass || [] );
if ( isChanel ) {
	addClass.push( 'mdl_productcarousel_item--chanel' );
}

if ( item.hoverimage ) {
	addClass.push( 'mdl_productcarousel_item--has_modelview' );
}

const [ width, height ] = ( function() {
	if ( 'recommendations' === template ) {
		return [ 330, 440 ];
	} else {
		return [ 192, 256 ];
	}
} )();

__p+='\n\n<article class="mdl_productcarousel_item en_griditem '+
((__t=( addClass.join( ' ' ) ))==null?'':__t)+
'"\n	';
 if ( 'Strategy' === element.type ) { 
__p+=' data-dy-product-id="'+
((__t=( item.sku ))==null?'':__t)+
'" data-dy-strategy-id="'+
((__t=( element.strId ))==null?'':__t)+
'"';
 } 
__p+='\n	';
 if ( 'Campaign' === element.type ) { 
__p+=' data-slot-id="'+
((__t=( element.slotId ))==null?'':__t)+
'"';
 } 
__p+='\n	data-eec-id="'+
((__t=( item.artikelid ))==null?'':__t)+
'"\n	data-eec-list="'+
((__t=( item.url ))==null?'':__t)+
'"\n	data-eec-name="'+
((__t=( element.escAttrOutput( item.name ) ))==null?'':__t)+
'"\n	data-eec-brand="'+
((__t=( element.escAttrOutput( item.brand ) ))==null?'':__t)+
'"\n	data-eec-currency="'+
((__t=( item.currency_code ))==null?'':__t)+
'"\n	data-eec-category="'+
((__t=( element.escAttrOutput( item.Categorypath_lvl2 ) ))==null?'':__t)+
'"\n	data-eec-position="'+
((__t=( index + 1 ))==null?'':__t)+
'"\n	data-eec-rating=""\n	data-eec-instock=""\n	data-eec-price="'+
((__t=( item.priceValue ))==null?'':__t)+
'"\n	data-eec-oldprice="'+
((__t=( item.oldpriceValue ))==null?'':__t)+
'"\n>\n\n	<div class="mdl_productcarousel_item__inner">\n		<div class="mdl_productcarousel_item__image-cnt">\n\n			<a href="'+
((__t=( item.deeplink ))==null?'':__t)+
'" class="mdl_productcarousel_item__image-cnt-inner '+
((__t=( addLinkClass ))==null?'':__t)+
'" '+
((__t=( addLinkAttributes ))==null?'':__t)+
' data-en-ratio-default="3-4">\n				<div class="mdl_productcarousel_item__image mdl_productcarousel_item__image--default">\n					<img class="mdl_productcarousel_item__image-img" src="'+
((__t=( element.getImageForType( item.image, template ) ))==null?'':__t)+
'"  width="'+
((__t=( width ))==null?'':__t)+
'" height="'+
((__t=( height ))==null?'':__t)+
'" alt="'+
((__t=( escape( decodeURIComponent( item.manufacturer || item.brand ) + ' ' + item.name) ))==null?'':__t)+
'" loading="lazy" sizes="(max-width: 420px) 192px, 330px" srcset="'+
((__t=( element.getSourceSet( item.image, template ) ))==null?'':__t)+
'" />\n				</div>\n				';
 if ( item.hoverimage ) { 
__p+='\n				<div class="mdl_productcarousel_item__image mdl_productcarousel_item__image--hover">\n					<img class="mdl_productcarousel_item__image-img en_js_hide_onerror" src="'+
((__t=( element.getImageForType( item.hoverimage, template ) ))==null?'':__t)+
'" width="'+
((__t=( width ))==null?'':__t)+
'" height="'+
((__t=( height ))==null?'':__t)+
'" alt="'+
((__t=( escape( decodeURIComponent( item.manufacturer || item.brand ) + ' ' + item.name) ))==null?'':__t)+
'" loading="lazy" sizes="(max-width: 420px) 192px, 330px" srcset="'+
((__t=( element.getSourceSet( item.hoverimage, template ) ))==null?'':__t)+
'" />\n				</div>\n				';
 } 
__p+='\n\n				';
 if ( 'crossselling' !== template && ! isChanel ) { 
__p+='\n					';
 if ( item.sale && 'number' === typeof item.salesPercentage ) { 
__p+='\n						<div class="mdl_productcarousel_item__badges en_badges en_badges--stacked">\n							<div class="en_badge en_badge--sale en_format_bold">-'+
((__t=( item.salesPercentage.toFixed() ))==null?'':__t)+
'&#37;</div>\n							';
 if ( item.voucherSalesPercentage )  { 
__p+='\n								<div class="en_badge en_badge--extra-sale en_format_bold">-'+
((__t=( item.voucherSalesPercentage.toFixed() ))==null?'':__t)+
'&#37;% extra</div>\n							';
 } 
__p+='\n						</div>\n					';
 } 
__p+='\n\n					';
 if ( item.badges && item.badges.length > 0 || item.new || item.onlineonly ) { 
__p+='\n						<div class="mdl_productcarousel_item__badges en_badges en_badges--bottom en_badges--stacked">\n							';
 if ( item.new ) { 
__p+='\n								<div class="en_badge en_format_bold">NEU</div>\n							';
 } 
__p+='\n\n							';
 if ( item.badges && item.badges.length > 0 ) { 
__p+='\n								';
 Object.values( item.badges || [] ).forEach( function( badge ) { 
__p+='\n									<div class="en_badge '+
((__t=( badge.cssicon ))==null?'':__t)+
'">\n										'+
((__t=( badge.title ))==null?'':__t)+
'\n									</div>\n								';
 }) 
__p+='\n							';
 } 
__p+='\n\n							';
 if ( item.onlineonly ) { 
__p+='\n								<div class="en_badge">Nur Online</div>\n							';
 } 
__p+='\n						</div>\n					';
 } 
__p+='\n				';
 } 
__p+='\n\n			</a>\n\n			';
 if ( 'crossselling' !== template && ! isChanel ) { 
__p+='\n				<a href="'+
((__t=( detailPageUrl ))==null?'':__t)+
'" class="mdl_productcarousel_item__cart-button en_js_open_popup acl_js_load_popup" data-en-popup-target="#popup_article" title="Schnellansicht"></a>\n			';
 } 
__p+='\n\n			';
 if ( userdata?.data?.user?.loggedIn ) { 
__p+='\n				<a href="'+
((__t=( element.getWishlistLink( userdata ) ))==null?'':__t)+
'" class="mdl_productcarousel_item__wishlist-button js_toggle_wishlistproduct '+
((__t=( element.isOnWishlist( userdata ) ? 'is-on-wishlist' : '' ))==null?'':__t)+
'" data-aid="'+
((__t=( item.sku ))==null?'':__t)+
'" title="Auf die Wunschliste" rel="nofollow"> </a>\n			';
 } else { 
__p+='\n				<a href="'+
((__t=( element.getWishlistLink( userdata ) ))==null?'':__t)+
'" class="mdl_productcarousel_item__wishlist-button en_js_open_popup" data-aid="'+
((__t=( item.sku ))==null?'':__t)+
'" data-en-popup-target="#popup_login_register" title="Auf die Wunschliste" rel="nofollow"> </a>\n			';
 } 
__p+='\n\n		</div>\n\n		<div class="mdl_productcarousel_item__content-cnt">\n\n			<a href="'+
((__t=( item.deeplink ))==null?'':__t)+
'" class="mdl_productcarousel_item__content '+
((__t=( addLinkClass ))==null?'':__t)+
'" '+
((__t=( addLinkAttributes ))==null?'':__t)+
'>\n\n				<h3 class="mdl_productcarousel_item__info">\n					<div class="mdl_productcarousel_item__brand">'+
((__t=( item.brand ))==null?'':__t)+
'</div>\n					';
 if ( isChanel && item.produktserie ) { 
__p+='\n					<div class="mdl_productcarousel_item__series en_format_uppercase">'+
((__t=( item.produktserie ))==null?'':__t)+
'</div>\n					';
 } 
__p+='\n					<div class="mdl_productcarousel_item__name">'+
((__t=( item.shortdescription ))==null?'':__t)+
'</div>\n				</h3>\n\n				<div class="mdl_productcarousel_item__price en_spacer_top_small">\n					';
 if ( item.sale ) { 
__p+='\n					<span class="en_price_uvp">UVP</span>&nbsp;<span class="en_price en_price--old"><span class="en_price__currency">'+
((__t=( item.currency_code ))==null?'':__t)+
'&nbsp;</span>'+
((__t=( item.oldpriceFormat ))==null?'':__t)+
'</span>\n					<span class="en_price en_price--new"><span class="en_price__currency">'+
((__t=( item.currency_code ))==null?'':__t)+
'&nbsp;</span>'+
((__t=( item.priceFormat ))==null?'':__t)+
'</span>\n					';
 } else { 
__p+='\n					<span class="en_price"><span class="en_price__currency">'+
((__t=( item.currency_code ))==null?'':__t)+
'&nbsp;</span>'+
((__t=( item.priceFormat ))==null?'':__t)+
'</span>\n					';
 } 
__p+='\n\n					';
 if ( 'recommendations' === template && item.priceperunit ) { 
__p+='\n						<div class="en_text_infotext en_color--gray en_spacer_top_tiny">'+
((__t=( item.priceperunit ))==null?'':__t)+
'</div>\n					';
 } 
__p+='\n				</div>\n			</a>\n\n			<a href="'+
((__t=( item.deeplink ))==null?'':__t)+
'" class="mdl_productcarousel_item__cta '+
((__t=( addLinkClass ))==null?'':__t)+
'" '+
((__t=( addLinkAttributes ))==null?'':__t)+
' tabindex="-1">\n				';
 if ( 'crossselling' === template ) { 
__p+='\n					<span class="en_button en_button--style_solid en_button--size_tiny">Jetzt shoppen</span>\n				';
 } else { 
__p+='\n					<span class="en_button en_button--style_solid en_button--color_graphite en_button--size_small">Jetzt shoppen</span>\n				';
 } 
__p+='\n			</a>\n		</div>\n	</div>\n</article>\n';
}
return __p;
};
